import type { Schedule } from "../types";

// Mock data for useSchedules
export const mockSchedules: Schedule[] = [
  {
    id: "schedule_1",
    client_id: "demo_client",
    name: "Standard Business Hours",
    timezone: "America/New_York",
    rrules:
      "RRULE:FREQ=WEEKLY;BYDAY=FR,MO,SU;BYHOUR=9;BYMINUTE=0;DURATION=885\nRRULE:FREQ=WEEKLY;BYDAY=TH,WE;BYHOUR=9;BYMINUTE=0;DURATION=480\nRRULE:FREQ=WEEKLY;BYDAY=TU;BYHOUR=9;BYMINUTE=0;DURATION=840\nRRULE:FREQ=WEEKLY;BYDAY=SA;BYHOUR=9;BYMINUTE=0;DURATION=870",
    is_default: true,
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "schedule_2",
    client_id: "demo_client",
    name: "Extended Hours",
    timezone: "America/New_York",
    rrules:
      "RRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR,SA;BYHOUR=8;BYMINUTE=0;DURATION=600",
    is_default: false,
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "schedule_3",
    client_id: "demo_client",
    name: "Weekend Hours",
    timezone: "America/New_York",
    rrules: "RRULE:FREQ=WEEKLY;BYDAY=SA,SU;BYHOUR=10;BYMINUTE=0;DURATION=360",
    is_default: false,
    created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
];
